import { Filters } from '@air/next-icons';

export type SearchCommandFilterCountProps = {
  count: number;
};

export const SearchCommandFilterCount = ({ count }: SearchCommandFilterCountProps) => {
  return (
    <div className="absolute top-1/2 right-4 flex shrink-0 -translate-y-1/2 items-center">
      <div className="flex size-4 items-center justify-center">
        <Filters className="size-3" />
      </div>
      <div className="flex h-4 min-w-[16px] items-center justify-center rounded-2 bg-grey-4 px-1 font-bold text-10 text-grey-10">
        {count}
      </div>
    </div>
  );
};
